import React, { useState, useEffect, useContext, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm , useFieldArray } from 'react-hook-form';
import { Layout, ResetConfirmationModal } from '../../../../components';
import AppContext from '../../../../contexts/AppContext';
import { handleApi,  capitalize, AudioSpinner,useToast, SearchableDropdown } from '../../../../utils/utils';

const DeleteUser = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { initialUser } = location.state || {};
  const initialFormState = {
    employee_id: '',
    role_id:'',
    username: '',
  }
  const [user, setUser] = useState(initialFormState);
  const [roles, setRoles] = useState([]);
  const [formattedRoles, setFormattedRoles] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [formattedEmployees, setFormattedEmployees] = useState([]);
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null); //state to hold employee details
  const [selectedRoleDetails, setSelectedRoleDetails] = useState(null); //state to hold employee details
  const { userData, currentColor, actionCount,setActionCount} = useContext(AppContext);
  console.log('initialUser',initialUser)
  const { showToast, toastMessage } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false); // State for the reset confirmation modal
  const [focusedIndex, setFocusedIndex] = useState(null);
  const userRef = useRef(null); // Ref to the user content for PDF generation
  const quantityRefs = useRef([]);    // a ref for each quantity input field to manage focus

  const { register, control, watch, reset, setValue, getValues } = useForm({
    defaultValues: {
      employee_id: '',
      role_id:'',
      username: '',
      password: '',
    }
  });
  
  const watchedEmployeeId = watch('employee_id'); // Watch for changes on the 'employee_id' field
  // Delete, reusable function to fetch data. It now accepts `showToast` as a parameter.
  const fetchData = async (apiEndpoint, showToast) => {
    const apiMethod = 'GET';
    const cleanedData = {};
    const parameters = {};

    try {
      const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
      if (response.error) {
        console.error(`Error fetching data from ${apiEndpoint}: ${response.errorMessage}`);
        showToast(`Error: ${response.errorMessage}`, 'error'); // Use showToast here
        return null; // Return null on error
      }
      const { status, data } = response;
      if (status === 200) {return data; // Return the data on success
      } else {
        showToast(`Error ${status}: ${response.statusText}`, 'error'); // Use showToast here
        return null;
      }
    } catch (error) {
      showToast(error.message || `An unexpected error occurred while fetching ${apiEndpoint}.`, 'error'); // Use showToast here
      return null;
    }
  };
 
  useEffect(() => {
    const loadInitialData = async () => {// Fetch employees
      const employeesData = await fetchData('employees', showToast);
      if (employeesData) {
        setEmployees(employeesData);
        setFormattedEmployees(employeesData.map(c => ({
          value: c.id,
           label: `${c.first_name} ${c.last_name}`
        })));
      }
 
      // Fetch roles
      const rolesData = await fetchData('roles', showToast);
      console.log('rolesData',rolesData)
      if (rolesData) {
        setRoles(rolesData);
        // Filter out null/undefined values before mapping
        setFormattedRoles(rolesData.filter(r => r).map(r => ({
          value: r.id,
          label: r.name || '',
        })));
      }
    };
    loadInitialData();
  }, []);


// useEffect to populate the form on initial load
useEffect(() => {
  // Check if initialUser data exists and we have loaded the employees and roles data
  if (initialUser && employees.length > 0 && roles.length > 0) {
    // Find the employee and role details from the fetched data
    const initialEmployee = employees.find(emp => emp.id === initialUser.employee_id);
    console.log('initial employee sir',initialEmployee)
    const initialRole = roles.find(role => role.id === initialUser.role_id);
    if (initialEmployee) {setSelectedEmployeeDetails(initialEmployee);}    // Keep full employee object here
    if (initialRole) {setSelectedRoleDetails(initialRole);}
  }
}, [initialUser, employees, roles, setValue, setSelectedEmployeeDetails, setSelectedRoleDetails]);





  // Use a useEffect hook to update the employee details whenever the watchedEmployeeId changes
  useEffect(() => {
    if (watchedEmployeeId) {
      const selectedEmployee = employees.find(c => c.id === parseInt(watchedEmployeeId));
      setSelectedEmployeeDetails(selectedEmployee || null);
    } else {setSelectedEmployeeDetails(null); }
  }, [watchedEmployeeId, employees]);


  // const handleEmployeeSelection = (employee) => {
  //   setValue('employee_id', employee.value);
  //   setValue('username', employee.email);
  //   setSelectedEmployeeDetails(employee);
  // };

  
  const handleAction = (action) => {
    if (action === 'download') { showToast(`Simulated action: ${action}`, 'success');
    } else if (action === 'print') {window.print();
    } else {showToast(`Simulated action: ${action}`, 'success');}
  };


  const handleSubmit = async () => {

      setIsLoading(true);
      const apiEndpoint = 'users';
        try {
          const response = await handleApi(apiEndpoint, {}, userData, 'DELETE',  { id: initialUser.id });
          if (response.status === 200) {
            //setShowDeleteButton(false); //Hide the button on success

            showToast(response.data.message || 'Quotation deleted  successfully!', 'success');
          } 
            else {showToast(response.data.message || 'Error deleting  quotation !', 'error');}
        } catch (error) {
          showToast( error.message || 'Error deleting  quotation !', 'error');;}
        finally {
          setActionCount(actionCount + 1);
          setIsLoading(false);
        }
      };




  return (
    <Layout>
    <div className="min-h-screen text-white p-2 sm:p-4">
      {toastMessage.show && (
        <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded-lg shadow-md z-50
                        ${toastMessage.type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
          {toastMessage.message}
        </div>
      )}
    <div className="relative flex justify-between items-center mb-4">
          <h1 className="font-extrabold text-gray-800 tracking-wide flex-grow text-center">
            DEACTIVATE USER
          </h1>
          <div className="flex gap-2">
            <button
              handleSubmit
              onClick={() => handleSubmit()}
            className="mr-36 px-2 py-1 rounded-xl font-semibold text-white bg-cyan-200 hover:bg-gray-700 transition-all duration-300 flex items-center gap-1 text-sm sm:text-base"
            title="Delete">
         <svg className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 21H3a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v6" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 19a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21L17 17" />
            </svg>
          </button>
          
          <button
            onClick={() => navigate(-1)}
            className="p-2 rounded-full text-gray-800 bg-white hover:bg-gray-300 transition-all duration-300"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        </div>
   

      <div className="bg-gray-600 rounded-3xl shadow-lg p-2 sm:p-4 mx-auto max-w-[50%]">
        

        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <AudioSpinner />
            <p className="mt-4 text-gray-400">Loading. Please wait...</p>
          </div>
        ) : (
          
          <div className="space-y-6">
          <div className="space-y-6">
            <div className="flex flex-col gap-6 w-full"> 
              {/* 💡 FIX: Added p-2 sm:p-4 back to this inner div to maintain spacing */}
              {/* You can use a hidden input field for username since its value is set programmatically */}
              <input type="hidden" {...register('username')} />

              {/* Hidden inputs to register employee_id and role_id with react-hook-form */}
              <input type="hidden" {...register('employee_id')} />
              <input type="hidden" {...register('role_id')} />

              <div className="bg-gray-500 px-4 py-4 rounded-xl text-cyan-200 w-full">
                <div className="flex flex-col gap-4 text-xs">
                  {/* Parent container for Select Employee */}
                  <div className="flex justify-center ">
                    {/* Check if selectedEmployeeDetails and an image URL exist */}
                    {selectedEmployeeDetails?.photo_url ? (
                      <img
                        src={selectedEmployeeDetails.photo_url}
                        alt="Employee Profile"
                        className="w-24 h-24 rounded-full object-cover ring-2 ring-cyan-200 shadow-lg"
                      />
                    ) : (
                      <div className="w-24 h-24 rounded-full bg-gray-400 flex items-center justify-center text-gray-600 text-4xl font-bold ring-2 ring-cyan-200 shadow-lg">
                        {selectedEmployeeDetails?.first_name?.charAt(0) || 'NA'}{selectedEmployeeDetails?.last_name?.charAt(0) || 'NA'}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <label className="font-medium text-cyan-200 mb-1 text-center">Employee Name</label>
                    <input
                      type="text"
                      className="text-center w-full bg-gray-500 text-white border-b-2 focus:outline-none border-cyan-200 rounded-md p-1 opacity-70 cursor-not-allowed"

                      value={
                        selectedEmployeeDetails
                          ? `${selectedEmployeeDetails.first_name || ''} ${selectedEmployeeDetails.last_name || ''}`.trim() || 'NA'
                          : 'NA'
                      }
                      
                      readOnly
                      disabled
                    />
                  </div>
                  {/* Parent container for Select Role */}
                  <div className="flex flex-col">
                    <label className="font-medium text-cyan-200 mb-1 text-center">User Role</label>
                    <input
                      type="text"
                      className="text-center w-full bg-gray-500 text-white border-b-2 focus:outline-none border-cyan-200 rounded-md p-1 opacity-70 cursor-not-allowed"
                      value={selectedRoleDetails?.name || 'NA'}
                      readOnly
                      disabled
                    />
                  </div>


                  {/* Display section for selected employee details */}
                  {selectedEmployeeDetails && (
                <>
                  <div className="flex flex-col">
                    <label className="font-medium text-cyan-200 mb-1 text-center">Login Id</label>
                    <input
                      type="text"
                      className="text-center w-full bg-gray-500 text-white border-b-2 focus:outline-none border-cyan-200 rounded-md p-1 opacity-70 cursor-not-allowed"
                      value={selectedEmployeeDetails?.email || 'NA'}
                      readOnly
                      disabled
                    />
                  </div>
                </>
              )}
            </div>
          </div>     
        </div>
    </div>
  </div>
)}
  
  <div className="flex justify-end mt-2">
  
            
            <button

              onClick={() => navigate(-1)}
              className="px-4 py-2 rounded-xl font-semibold text-gray-800 bg-cyan-200 hover:bg-cyan-300 transition-all duration-300"
              disabled={isLoading}
            >
              {isLoading ? 'Closing...' : 'Close'}
            </button>
          </div>
      </div>
     
    </div>
    
    </Layout>
  );
};

export default DeleteUser;